import { isNil } from 'lodash';

import { LAST_SAVED_POSITION_NONEXIST } from '~/src/components/MediaPlayer/useGetCurrentUserMediaPosition';

const CLOSE_TO_END_THRESHOLD_IN_PERCENT = 0.95;

const CLOSE_TO_END_THRESHOLD_IN_SECONDS = 60;
const ADDITIONAL_CLOSE_TO_THE_END_RESERVE = 1;

export function getRestoredMediaPosition(lastSavedTime: number, mediaDurationInSec: number | null) {
  if (lastSavedTime === LAST_SAVED_POSITION_NONEXIST) {
    return lastSavedTime;
  }
  if (isNil(mediaDurationInSec)) {
    return lastSavedTime;
  }

  const isLessThanMinuteLeft =
    mediaDurationInSec - lastSavedTime <= CLOSE_TO_END_THRESHOLD_IN_SECONDS;

  if (isLessThanMinuteLeft) {
    return (
      mediaDurationInSec - (CLOSE_TO_END_THRESHOLD_IN_SECONDS + ADDITIONAL_CLOSE_TO_THE_END_RESERVE)
    );
  }

  const maxCloseToEndPositionInSec = mediaDurationInSec * CLOSE_TO_END_THRESHOLD_IN_PERCENT;
  const isCloseToTheEnd = lastSavedTime > maxCloseToEndPositionInSec;

  if (isCloseToTheEnd) {
    return maxCloseToEndPositionInSec;
  } else {
    return lastSavedTime;
  }
}
